import React from 'react';
import ComboSection from '../../../../components/Molecules/Card/ComboSection/ComboSection';
import { Col } from 'react-bootstrap';
import { MAKE_A_SELECTION, REACT_APP_CLOUD_FRONT,REACT_APP_IMAGES_VERSION,SELECT_AN_ITEM, TRY_2_COMBO } from '../../../../constants';
import { IItemCards, ISelectedItem } from '../../../../models/try2Combo';
import { Try2Combo } from './data';
import useCheckMobileScreen from '../../../../hooks/useCheckMobileScreen';
import { isItCreateYourOwnItem } from '../../../../helpers/helperMethods';

const ItemCard: React.FC<IItemCards> = (props) => {
  const {
    setSectionSelected,
    order,
    itemFromApi,
    itemDetails,
    selectedItem,
    sectionSelected,
    onRemoveClickHandler,
    onEditClickHandler,
  } = props;

  const isItMobile = useCheckMobileScreen();
  const makeASelection = isItMobile ? SELECT_AN_ITEM : MAKE_A_SELECTION

  const findSelectedItemAvailability = (find_id) => {
    const items = order.modifiers.filter((obj) => {
      return obj.is_selected;
    });
    return items.find((item) => item.item === find_id);
  };

  const Item = (selected: ISelectedItem, id: string) => {
    return (
      selected &&
      id === selected.item &&
      itemFromApi.sub_categories
        .map((category) => category.items)
        .flat()
        .find((item) => item.id == selected.id)
    );
  };

  const Category = (selected: ISelectedItem, id: string) => {
    return (
      selected &&
      id === selected.item &&
      itemFromApi.sub_categories.flat().find((item) => {
        return item.id == selected.category_id;
      })
    );
  };

  return (
    <>
      {Try2Combo.map((section, index) => {
        const selected: ISelectedItem = findSelectedItemAvailability(
          section.id
        );
        //? Get selected Item
        const item = Item(selected, section.id);
        //? Get selected category
        const category = Category(selected, section.id);
        
        // const isDisabled = item?.is_customizable !== undefined && !item?.is_customizable

        //? To By_pass this check for CYOI replace upper condition to commented one
        const isDisabled = item?.is_customizable !== undefined && !item?.is_customizable && !isItCreateYourOwnItem(item.is_create_your_own)
        
        return (
          <Col
            sm={itemDetails ? '6' : '6'}
            key={section.id}
            xs={itemDetails ? '6' : '6'}
          >
            <ComboSection
              id={section.id}
              title={isItMobile ? section.sm_title : section.title}
              onChange={(id, scroll) => setSectionSelected(id, scroll)}
              image={item ? `${REACT_APP_CLOUD_FRONT}${item.image}?version=${REACT_APP_IMAGES_VERSION}` : ''}
              itemName={category?.name ? item.name : makeASelection}
              addedItem={category?.name && item}
              changeItemSize={itemDetails ? '' : 'f-s18'}
              selectedItem={selectedItem}
              isItemSelected={Boolean(item)}
              sectionSelected={sectionSelected}
              onRemoveClickHandler={onRemoveClickHandler}
              onEditClickHandler={onEditClickHandler}
              comingFromItem={TRY_2_COMBO}
              checked={section.id === sectionSelected} textStart={''}
              isCustomizeable={isDisabled} />
          </Col>
        );
      })}
    </>
  );
};

export default ItemCard;
